import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import buildGraphcoolProvider from "ra-data-graphcool";
import React, { Component } from "react";
import { Admin, Resource } from "react-admin";
import addUploadCapabilities from "./addUploadCapabilities";
import authProvider from "./authProvider";
import { API_URL, AUTH_TOKEN } from "./constants";
import Resources from "./resources";
import polyglotI18nProvider from "ra-i18n-polyglot";
import turkishMessages from "ra-language-turkish";
import { domainMessages } from "./i18n";
import englishMessages from "ra-language-english";
import Layout from "./Layout";
import removeUnchangedFields from "./removeUnchangedFields";
import dieticianToUser from "./dieticianToUser";
import { merge } from "lodash";

const messages = {
  tr: merge(turkishMessages, domainMessages.tr),
  en: merge(englishMessages, domainMessages.en),
};
const i18nProvider = polyglotI18nProvider((locale) => messages[locale], "tr");

const httpLink = createHttpLink({
  uri: API_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
class App extends Component {
  constructor() {
    super();
    this.state = { dataProvider: null };
  }
  componentDidMount() {
    buildGraphcoolProvider({
      client: client,
    }).then((dataProvider) => this.setState({ dataProvider }));
  }

  render() {
    const { dataProvider } = this.state;

    if (!dataProvider) {
      return <div>Loading</div>;
    }

    return (
      <Admin
        dataProvider={dieticianToUser(
          removeUnchangedFields(addUploadCapabilities(dataProvider))
        )}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        layout={Layout}
        title="Om Meditasyon Admin"
      >
        
        
        <Resource
        name="Blog"
        list={Resources.BlogList}
        edit={Resources.BlogEdit}
        create={Resources.BlogCreate}
      />
      <Resource
        name="Category"
        list={Resources.CategoryList}
        edit={Resources.CategoryEdit}
        create={Resources.CategoryCreate}
      />
      <Resource
        name="File"
        list={Resources.FileList}
        edit={Resources.FileEdit}
      />

      <Resource
        name="Mindfulness"
        list={Resources.MindfulnessList}
        edit={Resources.MindfulnessEdit}
        create={Resources.MindfulnessCreate}
      />

      <Resource name="Order" 
      list={Resources.OrderList} 
      />

      <Resource name="Product"
       list={Resources.ProductList}
        />

      <Resource name="Snap" 
      list={Resources.SnapsList} 
      />

      <Resource name="Story"
       list={Resources.StoriesList}
        />

      <Resource
        name="Subscription"
        list={Resources.SubscriptionList}
        edit={Resources.SubscriptionEdit}
        create={Resources.SubscriptionCreate}
      />
      <Resource name="Tag" list={Resources.TagList} />

      <Resource
        name="User"
        list={Resources.UserList}
        edit={Resources.UserEdit}
      />
       
        
        
      </Admin>
    );
  }
}

export default App;
